import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';
export function PricingSection() {
  return <section className="w-full py-32 px-6 bg-[#0a0f0d] border-t border-gray-900" data-id="element-68">
      <div className="max-w-3xl mx-auto text-center" data-id="element-69">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="space-y-12" data-id="element-70">
          <h2 className="text-3xl md:text-5xl font-bold text-white leading-tight" data-id="element-71">
            Tu primer ebook no tiene que ser perfecto.{' '}
            <br className="hidden md:block" data-id="element-72" />
            <span className="text-[#00d4aa]" data-id="element-73">
              Tiene que estar terminado y listo para vender.
            </span>
          </h2>

          <div className="pt-8" data-id="element-74">
            <a href="https://aprendeemprendearg.com/cart/52712282784111:1" target="_blank" rel="noopener noreferrer" onClick={() => {
            if (window.fbq) {
              window.fbq('track', 'InitiateCheckout', {
                content_name: 'EBOOK CREATOR',
                content_category: 'GPT',
                value: 18990,
                currency: 'ARS'
              });
            }
          }} className="w-full md:w-auto inline-flex items-center justify-center bg-[#00d4aa] hover:bg-[#00bfa0] text-black font-bold text-xl px-10 py-6 rounded-xl transition-all transform hover:scale-105 space-x-3 no-underline shadow-xl shadow-[#00d4aa]/10" data-id="element-75">
              <span data-id="element-76">Empezar hoy por $18.990</span>
              <ArrowRight className="w-6 h-6" data-id="element-77" />
            </a>
          </div>
        </motion.div>
      </div>
    </section>;
}